import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { addMonths, format, parseISO } from 'date-fns';
import Header from './Header';
import LogoLoader from './component/logo/LogoLoader';

function Payment() {
  const [searchParams] = useSearchParams();
  const memberId = searchParams.get('id');
  const [member, setMember] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [planStartDate, setPlanStartDate] = useState(null);
  const [planEndDate, setPlanEndDate] = useState(null);

  //const plans = [
    //{ name: '1 Month', duration: 1, amount: 499, id:'LiJQoSuaNSC3DrLXdYas'},
    //{ name: '3 Months', duration: 3, amount: 1000, id:'1vPKFcQ5MhwGoh3BQzMy' },
  //];

  
// 1. Fetch Member Info when memberId changes
useEffect(() => {
  const fetchMember = async () => {
    try {
      const res = await axios.get(`/api/getMemberInfo?id=${memberId}`);

      // Sort fallback plans too
      const sortedFallbackPlans = res.data.plans.sort((a, b) => a.duration - b.duration);

      // Find the recommended plan
     // const recommendedPlan = sortedFallbackPlans.find(plan => plan.tag === "Recommended");
      
     
     setMember({
        name: res.data.name,
        email: res.data.email,
        planEndDate: res.data.planEndDate,
        plans: sortedFallbackPlans
      });

      // If there's a recommended plan, select it
      //if (recommendedPlan) {
      //  setSelectedPlan(recommendedPlan);
     // }

     
    } catch (err) {
      alert('Member not found');
    }
  };

  if (memberId) {
    fetchMember(); // 🔥 Only when memberId changes
  }
}, [memberId]); // ✅ ONLY memberId

// 2. Calculate Plan Dates when selectedPlan changes
useEffect(() => {
  if (selectedPlan && member) {
    const currentEndDate = new Date(member.planEndDate); 
    const today = new Date();

    let startDateObj;

    if (currentEndDate >= today) {
      startDateObj = new Date(currentEndDate);
      startDateObj.setDate(startDateObj.getDate() + 1);
    } else {
      startDateObj = today;
    }

    const planDurationInMonths = selectedPlan.duration; 
    const nextPlanEndDateObj = new Date(startDateObj);
    nextPlanEndDateObj.setMonth(nextPlanEndDateObj.getMonth() + planDurationInMonths);
    nextPlanEndDateObj.setDate(nextPlanEndDateObj.getDate() - 1);

    const formattedStart = startDateObj.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

    const formattedEnd = nextPlanEndDateObj.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

    setPlanStartDate(formattedStart);
    setPlanEndDate(formattedEnd);
  }
}, [selectedPlan, member]); // ✅ Plan date calculation when selectedPlan/member changes


  const handlePayNow = async () => {
    if (!selectedPlan) return alert('Please select a plan');
    setLoading(true);
    try {
      const res = await axios.post(`/api/createPaymentLink`, {
        memberId,
        plan: selectedPlan,
      });
      window.location.href = res.data.short_url;
    } catch (err) {
      alert('Error creating payment link');
    } finally {
      setLoading(false);
    }
  };

  
  if (!member) return (
        <div className="flex items-center justify-center min-h-screen">
          <LogoLoader theme="light" />
        </div>
      );

  
  return (
    <div className="container mx-auto px-4 py-4 flex flex-col items-center">
       <header className="container flex flex-col md:flex-row items-center justify-center bg-white">
    {/* Left side - Logo */}
    <div>
      <img src="header_logo.svg" alt="Logo" className="h-20 w-80" />
    </div>

    </header>
      <h2 className="text-2xl font-bold mb-2 mt-8">Hello, {member.name}</h2>
      <label className="text-gray-600 mb-6">{member.email}</label>

      <h3 className="text-xl font-semibold mb-4">Choose your plan</h3>

      <div className="flex overflow-x-auto gap-4 py-2 w-full justify-center-safe">
        {member.plans.map((plan) => (
          <div
            key={plan.name}
            className="flex flex-col items-start p-4 bg-[#E6F4FF] rounded-lg min-w-[150px] flex-shrink-0 relative gap-2"
          >
            <div className="flex items-center w-full">
              <input
                type="radio"
                name="plan"
                id={plan.name}
                onChange={() => setSelectedPlan(plan)}
                className="mr-auto"
              />
              {plan.tag && (
                <span
                  className={`text-[10px] px-2 py-1 rounded ml-auto font-bold border
                    ${plan.tag === 'Recommended' ? 'bg-green-100 text-green-600 border-green-500' : 'bg-blue-100 text-blue-600 border-gray-400'}`}
                >
                  {plan.tag === "Recommended" ? 'Recommended' : plan.tag === 'Best Seller' ? 'Best Seller' : ''}
                </span>
              )}
            </div>

            <label htmlFor={plan.name} className="font-bold cursor-pointer">{plan.name}</label>
            <label htmlFor={plan.name} className="cursor-pointer">₹{plan.amount}</label>
          </div>
        ))}
      </div>

      {/* Billing Summary */}
      <div className="bg-white p-8 rounded-2xl shadow-lg max-w-md w-full mt-8 text-center">
        <h2 className="text-2xl flex font-semibold mb-6">
          You will be billed: <span className="text-3xl font-bold">₹ {selectedPlan ? selectedPlan.amount : ''}</span>
        </h2>
        <div className="flex justify-between items-center mb-8 text-left">
          <div className="flex-1">
            <p className="text-gray-500 text-sm">Your Plan Starts</p>
            <p className="font-bold text-base">{planStartDate}</p>
          </div>
          <div className="flex-1 text-right">
            <p className="text-gray-500 text-sm">Your Plan Ends</p>
            <p className="font-bold text-base">{planEndDate}</p>
          </div>
        </div>
      </div>

      {/* Pay Now Button */}
      <button
        onClick={handlePayNow}
        disabled={loading}
        className="mt-6 bg-[#00A6FB] hover:bg-[##00A6FB]-700 text-white font-semibold py-3 px-8 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? 'Paying...' : 'Pay Now'}
      </button>
    </div>
  );
  
}

export default Payment;
